import {
  parseAsAccountType,
  parseAsArrayOf,
  parseAsBook,
  parseAsClassification,
  parseAsParty,
  parseAsString,
  parseAsStringLiteral,
  useQueryStates,
} from '@vrplatform/query-params';
import { day, hasValue } from '@vrplatform/utils';

const VIEW = ['non-zero'] as const;

export const useTrialBalanceTableFilter = () => {
  'use memo';

  const [filter, setFilter] = useQueryStates({
    search: parseAsString,
    date: parseAsString.withDefault(
      `${day().startOf('month').yyyymmdd()}...${day().endOf('month').yyyymmdd()}`
    ),
    classifications: parseAsArrayOf(parseAsClassification),
    party: parseAsParty,
    type: parseAsAccountType,
    ledger: parseAsBook,
    view: parseAsStringLiteral(VIEW),
  });

  const isFiltered = Object.values(filter).some(hasValue);

  return {
    filter,
    setFilter,
    isFiltered,
    reset: () =>
      setFilter({
        search: undefined,
        date: undefined,
      }),
  };
};
